import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  paper: {
    borderBottom: 0,
  },
  lineAction: {
    paddingBlock: theme.spacing(1),
  },
}))

export default styles
